import { Builder } from '@builder.io/react';
import { BUILDER_DIVIDER_NAMES } from '../BuilderComponentsName';
import { AffordablePlansDivider } from '../../specials';

Builder.registerComponent(AffordablePlansDivider, {
    name: BUILDER_DIVIDER_NAMES.AffordablePlansDivider,
});
